import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row bg-white w-100-per ml-0 min-height-100vh" }
const _hoisted_2 = { class: "col-lg-7 pr-0 pl-0 min-height-100vh pad-100-b registration-bg" }
const _hoisted_3 = { class: "row pad-15-t push-10-l push-10-r" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-6 push-5-t min-height-70" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.advicepay.com" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "min-height-70",
      src: "/assets/img/advicepay-primary-logo-evergreen-rgb.svg",
      width: "325"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "col-xs-6 text-right push-10-t"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "/logoff",
  class: "push-15-l"
}, "Log Out", -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "row push-10-r text-right hidden-lg"
}
const _hoisted_8 = { class: "col-xs-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("em", { class: "text-muted fs-12 dis-block" }, "Selected Plan", -1 /* HOISTED */)
const _hoisted_10 = { class: "col-xs-11 col-sm-8 col-md-6 col-lg-10 col-centered text-left push-20 hidden-lg" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left push-5-r" }, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "col-xs-11 col-sm-8 col-md-6 col-lg-10 col-centered" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row push-15-l" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/img/individual.svg",
    class: "push-10-r"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-600" }, "Essential")
], -1 /* HOISTED */)
const _hoisted_16 = { class: "flex-row-start-right-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("em", { class: "text-muted fs-12 dis-block" }, "Starting from", -1 /* HOISTED */)
const _hoisted_18 = { class: "inline-block" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "h5 text-muted" }, "/mth", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row push-15-l" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/img/professional.svg",
    class: "push-10-r"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-600" }, "Professional")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "flex-row-start-right-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("em", { class: "text-muted fs-12 dis-block" }, "Starting from", -1 /* HOISTED */)
const _hoisted_23 = { class: "inline-block" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "h5 text-muted" }, "/mth", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row push-15-l" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/img/enterprise.svg",
    class: "push-10-r"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-600" }, "Enterprise")
], -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row-start-right-item" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "dis-block" }, "Let's Talk"),
  /*#__PURE__*/_createElementVNode("em", { class: "h6 text-muted" }, "Contact Sales for Custom Pricing")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchAccountDropdown = _resolveComponent("SwitchAccountDropdown")!
  const _component_RefreshPlanOffering = _resolveComponent("RefreshPlanOffering")!
  const _component_RadioTile = _resolveComponent("RadioTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.currentUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_SwitchAccountDropdown, {
                class: "inline-block",
                currentUser: _ctx.currentUser,
                accessibleUsers: _ctx.accessibleUsers
              }, null, 8 /* PROPS */, ["currentUser", "accessibleUsers"]),
              _hoisted_6
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.currentUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.panelHidden = false), ["prevent"]))
              }, _toDisplayString(_ctx.$filters.capitalize(_ctx.plan)), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-xs-11 col-md-10 col-sm-8 col-lg-9 col-centered side-column-always-show-wide", { 'hidden': !_ctx.panelHidden }])
      }, [
        _renderSlot(_ctx.$slots, "content")
      ], 2 /* CLASS */)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["col-xs-12 col-lg-5 text-center pad-30-b side-column-always-show-wide side-column-hide-narrow min-height-100vh registration-plan-offering-container", { 'hidden': _ctx.panelHidden }])
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.panelHidden = true), ["prevent"])),
          class: "text-white"
        }, [
          _hoisted_11,
          _createTextVNode(" Go Back")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.changingPlan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_RefreshPlanOffering, {
                class: "bg-white pad-20",
                plan: _ctx.internalPlan,
                currentUser: _ctx.currentUser,
                coupon: _ctx.coupon
              }, null, 8 /* PROPS */, ["plan", "currentUser", "coupon"]),
              (_ctx.currentUser && !_ctx.planIsSelfPayRep)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changingPlan = true), ["prevent"])),
                    class: "text-black inline-block push-15-t"
                  }, "Change subscription plan"))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.changingPlan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_RadioTile, {
                modelValue: _ctx.internalPlan,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalPlan) = $event)),
                inputVal: _ctx.accountTypes.ESSENTIAL,
                class: "bg-white push-10-t flex-row-start pad-15"
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("strong", _hoisted_18, "$" + _toDisplayString(_ctx.planData(_ctx.accountTypes.ESSENTIAL).cost) + ".00", 1 /* TEXT */),
                    _hoisted_19
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "inputVal"]),
              _createVNode(_component_RadioTile, {
                modelValue: _ctx.internalPlan,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalPlan) = $event)),
                inputVal: _ctx.accountTypes.PROFESSIONAL,
                class: "bg-white push-10-t flex-row-start pad-15"
              }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("strong", _hoisted_23, "$" + _toDisplayString(_ctx.planData(_ctx.accountTypes.PROFESSIONAL).cost) + ".00", 1 /* TEXT */),
                    _hoisted_24
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "inputVal"]),
              _createVNode(_component_RadioTile, {
                modelValue: _ctx.internalPlan,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.internalPlan) = $event)),
                inputVal: _ctx.accountTypes.ENTERPRISE,
                class: "bg-white push-10-t flex-row-start pad-15"
              }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _hoisted_26
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "inputVal"]),
              (_ctx.differentPlanSelected)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePlan && _ctx.updatePlan(...args)), ["prevent"])),
                    class: "btn btn-primary btn-block btn-md push-15-t"
                  }, "Update Subscription"))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelPlanChange && _ctx.cancelPlanChange(...args)), ["prevent"])),
                class: "text-white inline-block push-15-t"
              }, "Cancel")
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ]))
}